import { render, staticRenderFns } from "./shareComponent.vue?vue&type=template&id=48b538c6&"
import script from "./shareComponent.vue?vue&type=script&lang=js&"
export * from "./shareComponent.vue?vue&type=script&lang=js&"
import style0 from "./shareComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports